import Wrapper from "../assets/wrappers/Navbar"
import { FaAlignLeft, FaUserCircle, FaCaretDown } from 'react-icons/fa'
import { MdLogout } from 'react-icons/md'
import { useAppContext } from '../context/appContext'
import Logo from './Logo'
import { useState } from "react"

const Navbar = () => {
    const { toggleSidebar, logoutUser, user, showLogout, changeShowLogout } = useAppContext()
    return (
        <Wrapper>
            <div className="nav-center">
                <button
                    type="button"
                    className="toggle-btn"
                    onClick={toggleSidebar}>
                    <FaAlignLeft />
                </button>
            </div>
            <div className="heading" onClick={() => changeShowLogout(!showLogout)}>
                <Logo />
                <h3 className="logo-text">Dashboard</h3>
            </div>
            <div className="btn-container">
                <button
                    type="button"
                    className="btn"
                    onClick={() => changeShowLogout(!showLogout)}>
                    <FaUserCircle />
                    {user?.firstName}
                    <FaCaretDown />
                </button>
                <div className={showLogout ? "dropdown show-dropdown" : "dropdown"}>
                    <button
                        type="button"
                        className="dropdown-btn"
                        onClick={logoutUser}>
                        <MdLogout />Logout
                    </button>
                </div>
            </div>
        </Wrapper>
    )
}

export default Navbar